import { jsx as _jsx } from "@redneckz/uni-jsx/jsx-runtime";
import { TabItem } from './TabItem.js';
export const renderTab = (activeTab, onClick, type) => (tab, i) => (_jsx(TabItem, { isActive: tab === activeTab, onClick: onClick, type: type, item: tab }, String(i)));
//# sourceMappingURL=renderTab.js.map